module.exports = __webpack_public_path__ + "static/media/mayank.73923ec5.jpg";